import Can from "./Can.jsx";

export default Can;
